<template>
  <div class="loginInput">
    <!-- <input class="phoneQuery" v-focus id="phoneQuery" type="number" ref="email" v-model="params.value1"  placeholder="请输入预留手机号" pattern="[0-9]*" @input="onInput" /> -->
    <van-field
      class="phoneQuery"
      v-model="params.value1"
      readonly
      placeholder="请输入预留手机号"
    />
    <div class="code">
      <van-field
        class="codeInput"
        v-model="phoneCode"
        type="number"
        placeholder="请输入4位验证码"
        @input.native="onInputCode"
        maxlength="4"
      />
      <van-button
        class="toObtain"
        @click.native="getsendSms"
        type="default"
        >{{ innerText }}</van-button
      >
    </div>
    <div class="verificationCode">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        @click.native="onNext"
      >确定</van-button>
    </div>
  </div>
</template>
<script>
import { reportInfo } from '@/api/report'
import { sendCheckSms, checkCheckCode} from '@/api/login'
import Storage from '@/tools/storage'
export default {
  name: 'verifyPhone',
  // props: ['checked'],
  data() {
    return {
      params: {
        value1: '',
        pattern: /^1[3456789]\d{9}$/,
        rules: true
      },
      show: false,
      statusBtn: true,
      phoneCode: "",
      codeBool: true,
      innerText: "获取验证码",
    }
  },
  watch: {
   
  },
  methods: {
    async getsendSms() {
      console.log(this.$route)
      this.djsFn();
      let data = { exam_id: this.$route.query.exam_id };
      let res = await sendCheckSms(data);
    },
    djsFn() {
      let timer = null;
      clearInterval(timer); //这句话至关重要
      let time = 60;
      let that = this;
      timer = setInterval(function() {
        if (time <= 0) {
          that.innerText = "";
          that.innerText = "重新获取";
          that.codeBool = false;
          clearInterval(timer);
        } else {
          that.codeBool = true;
          that.innerText = "";
          that.innerText = "剩余时间" + time + "秒";
          time--;
        }
      }, 1000);
    },
    async onNext() {
      if(this.phoneCode == ''){
        alert('验证码不能为空')
        return
      }
      let res = await checkCheckCode({exam_id: this.$route.query.exam_id, code: this.phoneCode})
      if(res) {
        this.getReportInfo()
      }
    },
    async getReportInfo() {
      let paramsV = this.$route.query
      let res = await reportInfo({
        ...paramsV,
        phone: this.params.value1,
        type: 2
      })
      console.log('测试',res)
      if (res) {
        // charge_mode收费模式  
        // 1.向患者结算（ 患者支付）
        // 2.向医院结算（医院托管）
        // 3.医院代收
        console.log(res.charge_mode, res.pay)
        if (res.charge_mode == 1 && res.pay == 2) {
          //向患者结算（ 患者支付）
          Dialog.confirm({
            title: '提示',
            message: '你输入的查询订单未支付，请支付后查看',
            confirmButtonText: '去支付'
          })
            .then(() => {
              this.$router.push({
                name: 'reportList',
                params: { isSure: true, exam_id: res.exam_id }
              })
            })
            .catch(() => {
              this.$router.push({
                name: 'reportList',
                params: { isSure: false }
              })
            })
        } else if (res.charge_mode == 3 && res.pay == 2) {
          //医院代收
          this.$router.push({
            name: 'reportList',
            params: { charge_mode: true }
          })
        } else {
          //report_see 报告未写之前公众号是否能查看影像
          // 1 可以查看  -----可以转发报告页面
          // 0 不可以查看 直接跳到报告列表
          //已经支付 pay 1
          if (res.report_see == 0) {
            if (res.info[0].exam_status < 7) {//不存在检查
              this.$router.push({ path: '/reportUnfinished' })
              return
            } else {
              if(res.info.length>0){
                Storage.set('code', res.code)
                Storage.set('examStatus', res.examStatus)
                Storage.set('reportInfo', res.info)
                Storage.set('studyId', res.info[0].study_id)
                this.$router.push({ path: '/reportInfo/report' })
              }else if(res.info.length === 0 && res.code === 2){
                Dialog.confirm({
                  title: '提示',
                  messageAlign: 'left',
                  showCancelButton: false,
                  confirmButtonText:'我知道了',
                  message:`<div style="white-space:normal;">
                            <div style="font-weight: 500">未查询到检查！可能由以下原因导致：</div>
                            <ol style="list-style: decimal;margin-left: 15px;"><li>1. 您在医院就诊时预留手机号、身份证号等个人信息有误，请至医院窗口处修改</li><li>2. 您输入的姓名、身份证号、手机号、就诊卡、门诊/住院号、病历号等信息有误，您可以通过“个人中心-添加绑定”重新查询尝试</li>
                              <li>3.你的检查未完成或正在上传，请耐心等待</li><</ol>
                          </div>`,
                })
              }
            }
          } else {
            if(res.info.length>0){
              Storage.set('code', res.code)
              Storage.set('examStatus', res.examStatus)
              Storage.set('reportInfo', res.info)
              Storage.set('studyId', res.info[0].study_id)
              this.$router.push({ path: '/reportInfo/report' })
            }else if(res.info.length === 0 && res.code === 2){
              Dialog.confirm({
                  title: '提示',
                  messageAlign: 'left',
                  showCancelButton: false,
                  confirmButtonText:'我知道了',
                  message:`<div style="white-space:normal;">
                            <div style="font-weight: 500">未查询到检查！可能由以下原因导致：</div>
                            <ol style="list-style: decimal;margin-left: 15px;"><li>1. 您在医院就诊时预留手机号、身份证号等个人信息有误，请至医院窗口处修改</li><li>2. 您输入的姓名、身份证号、手机号、就诊卡、门诊/住院号、病历号等信息有误，您可以通过“个人中心-添加绑定”重新查询尝试</li>
                              <li>3.你的检查未完成或正在上传，请耐心等待</li><</ol>
                          </div>`,
                })
            }
            
          }
        }
      }
    }
  },
  created() {
    this.params.value1 = this.$route.query.phone
  }
}
</script>
<style lang="scss" scoped>
.loginInput {
  width: 90%;
  margin: 50px auto 0;
}
.code {
  display: flex;
  margin-top: 20px;
}
.codeInput {
  width: 65%;
}
.toObtain {
  margin-left: 20px;
  color: rgb(19, 172, 193);
  font-size: 14px;
}
</style>

